export default __webpack_public_path__ + "static/media/thumbnail.dd4c7c44.png";